
export type VerifyAmount200 = {
  actualAmount?: number;
  isValid: boolean;
  message?: string;
  success: boolean;
};
